module.exports = __webpack_public_path__ + "assets/6d3306b6f7f6d4f38e750c11be1ebf89.jpg";